import styled, { useTheme } from "styled-components";
import percentageIcon from "@/assets/images/icons/population/percentage.png";
import userIcon from "@/assets/images/icons/population/users.svg";
import walletIcon from "@/assets/images/icons/population/wallet.svg";
import { device } from "@/lib/constants";
import { Paragraph } from "../styled";

export const PopulationTable = (): JSX.Element => {

	const theme = useTheme();

	const { green, blue, yellow } = theme.colors.primary;

	return (
		<div>
			<Cards>
				<PopulationCard style={{ marginRight: 15 }}>
					<TitleSection>
						<PopulationCardIcon src={userIcon} />
						<PopulationCardTitle style={{ color: green }}>
							---
						</PopulationCardTitle>
					</TitleSection>
					<Paragraph>Applications</Paragraph>
				</PopulationCard>

				<PopulationCard style={{ marginRight: 15 }}>
					<TitleSection>
						<PopulationCardIcon src={walletIcon} />
						<PopulationCardTitle style={{ color: blue }}>
							---
						</PopulationCardTitle>
					</TitleSection>
					<Paragraph>Pitches</Paragraph>
				</PopulationCard>

				<PopulationCard>
					<TitleSection>
						<PopulationCardIcon src={percentageIcon} />
						<PopulationCardTitle style={{ color: yellow }}>
							---
						</PopulationCardTitle>
					</TitleSection>
					<Paragraph>Active Teams</Paragraph>
				</PopulationCard>
			</Cards>
		</div>
	);
};

const PopulationCardTitle = styled(Paragraph)`
  font-size: 24px;
  font-family: 'ProximaNova', sans-serif;
  margin-left: 5px;
`;

const PopulationCardIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const TitleSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
`;

const Cards = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  @media ${device.tablet} {
    flex-direction: column;
  }
`;

const PopulationCard = styled.div`
  height: 72px;
  background-color: var(--accentBg);
  border-radius: 8px;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  @media ${device.tablet} {
    width: 100%;
    height: 72px;
    margin-bottom: 16px;
    padding: 16px;
    margin-right: 0 !important;
  }
`;
